import { TProjectData } from "../model/types";

export const MAX_FILES = 20;
export const MAX_TOTAL_SIZE_BYTES = 100 * 1024 * 1024; // 100MB
export const ACCEPTED_FILE_TYPES = ".pdf,.pptx,.jpg,.jpeg,.png,.txt,.csv,.xlsx,.xls,.xlsm,.docx";
export const ACCEPTED_LOGO_TYPES = ".jpg,.jpeg,.png";
export const initialProjectData: TProjectData = {
  name: "",
  projectTemplateSlug: "",
  description: "",
  repository: [],
  language: "english",
  decisionContext: "",
  successMetrics: "",
  targetAudience: "",
  additionalContext: "",
  chaptersInstructions: {},
  projectInstructions: "",
  presentationPrompt: ""
};

export const languageOptions = [
  { value: "english", label: "English" },
  { value: "japanese", label: "Japanese" }
];
